import LayoutBackend from '@/layouts/variations/Backend.vue';
import store from '@/store/index';
import { isPhoneAuth } from '@/router/helpers.js';

const Home = () => /* webpackChunkName: "group-my-assets" */ import('@/views/MyAssets/Home.vue');

const MyBuildings = () => /* webpackChunkName: "group-my-assets" */ import('@/views/MyAssets/APT/Own.vue');
const MyNftDetail = () => /* webpackChunkName: "group-my-assets" */ import('@/views/MyAssets/APT/Detail.vue');
const MyOMC = () => /* webpackChunkName: "group-my-assets" */ import('@/views/MyAssets/OMC/OMC.vue');
const MyOMCDetail = () => /* webpackChunkName: "group-my-assets" */ import('@/views/MyAssets/OMC/OMCDetail.vue');
const MyRegistration = () =>
  /* webpackChunkName: "group-my-assets" */ import('@/views/MyAssets/Menus/Registration/RegTicketHistory.vue');
const MyClover = () =>
  /* webpackChunkName: "group-my-assets" */ import('@/views/MyAssets/Menus/Clover/CloverHistory.vue');

const getNftDetail = () => async (to, from, next) => {
  try {
    await store.dispatch('getNftDetail', to.params.nftId);

    next();
  } catch (error) {
    if (error?.response?.status === 401) {
      next('/login');
    } else {
      next('/assets/buildings');
    }

    // store.commit('setNftDetailData', {
    //   ownerName: '배유나',
    //   buildingName: '동부센트레빌아스테리움서울',
    //   address: '서울특별시 용산구 한남동 72-1',
    //   registeredAt: '2022-01-27T00:00:00',
    //   serialNum: 'SEL-735646',
    //   editionNum: '#212',
    //   tokenId: '2002',
    //   tokenLink: '',
    //   contractAddr: '0xd899ce6b63ded01346742d17861c46fa22a0f778',
    //   currentPrice: '16,111.01',
    //   imgUrl: 'https://nftimg.openmeta.city/sel/A11170000035/000001.png',
    // });
    next();
  }
};

const assets = [
  {
    path: '/assets',
    name: 'Assets',
    redirect: '/assets/home',
    component: LayoutBackend,
    beforeEnter: isPhoneAuth(['getUsrAssets']),
    children: [
      {
        path: 'home',
        name: 'AssetsHome',
        component: Home,
      },
      {
        path: 'buildings',
        name: 'MyBuildings',
        component: MyBuildings,
      },
      {
        path: 'buildings/:nftId',
        name: 'MyNftDetail',
        component: MyNftDetail,
        beforeEnter: getNftDetail(),
        props: true,
      },
      {
        path: 'omc',
        name: 'MyOMC',
        component: MyOMC,
      },
      {
        path: 'omc/:detailId',
        name: 'MyOMCDetail',
        component: MyOMCDetail,
        props: true,
      },
      {
        path: 'registration',
        name: 'MyRegistration',
        component: MyRegistration,
      },
      {
        path: 'clover',
        name: 'MyClover',
        component: MyClover,
      },
    ],
  },
];

export { assets };
